const localStorageManager = {};

localStorageManager.setCooldown = (item) => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(item, (+new Date()).toString());
};

localStorageManager.getCooldown = (item, duration) => {
  if (typeof window === 'undefined') {
    return false;
  }

  return +localStorage.getItem(item) <= +new Date() - duration;
};

localStorageManager.setFlag = (item, flag) => {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(item, flag.toString());
};

localStorageManager.getFlag = (item) => {
  if (typeof window === 'undefined') {
    return false;
  }

  return !!JSON.parse(localStorage.getItem(item));
};

export default localStorageManager;
